import React, { Component } from 'react';

import strings from '../../../assets/localization';
import Modal from '../../UI/Modal/Modal';
import Button from '../../UI/Button/Button';
import Input from '../../UI/Input/Input';
import InputError from '../../UI/InputError/InputError';
import Spinner from '../../UI/Spinner/Spinner';
import NavbarElement from '../../Navigation/Navbar/NavbarElement/NavbarElement';
import classes from './PasswordRecovery.module.css';
import config from '../../../constants/config';
import AlertError from '../AlertError/AlertError';
import Alert from '../../UI/Alert/Alert';
import { checkEmailDomainTypo } from '../../../assets/helpers/emailTypoDetection';
import { sanitizeEmailInput } from '../../../assets/helpers/emailInputSanitizer';

class PasswordRecovery extends Component {
  constructor(props) {
    super(props);
    this.textEmailInput = React.createRef();
    this.state = {
      isEmailEmpty: true,
      email: '',
      focus: false,
    };
  }
  onEmailChange = (e) => {
    const rawValue = e.target.value;
    const sanitizedValue = sanitizeEmailInput(rawValue);
    this.setState({ email: sanitizedValue });
    const emailLength = sanitizedValue.length;
    if (emailLength === 6) {
      this.setState({ isEmailEmpty: false });
    }
  };
  focusedInput = () => {
    if (!this.state.focus) {
      this.setState({ focus: true });
    }
  };
  discardFocusedInput = () => {
    if (this.state.focus) {
      this.setState({ focus: false });
    }
  };
  renderRecoveryMessageAlert = () => {
    return (
      <Alert>
        <p className={classes.ModalText}>{strings.recoveryMessage1}</p>
        <div className={classes.ButtonWrapper}>
          <Button clicked={this.props.goBack}>{strings.Close}</Button>
        </div>
      </Alert>
    );
  };
  renderEmailError = () => {
    const { isEmailEmpty } = this.state;

    if (!isEmailEmpty) {
      // First check basic email format validation
      const isValidFormat = config.EMAIL_REGEX.test(this.state.email);
      if (!isValidFormat) {
        return (
          <InputError style={{ display: 'block' }}>
            {strings.emailError}
          </InputError>
        );
      }

      // Only check for Gmail typos if basic format is valid
      const typoCheck = checkEmailDomainTypo(this.state.email);
      if (typoCheck.hasTypo) {
        return (
          <InputError style={{ display: 'block' }}>
            {strings.emailGmailTypoError}
          </InputError>
        );
      }
    }

    return null;
  };
  validateEmail = () => {
    const isValidFormat = config.EMAIL_REGEX.test(this.state.email);
    const typoCheck = checkEmailDomainTypo(this.state.email);
    return isValidFormat && !typoCheck.hasTypo;
  };
  onEmailKeyDown = (e) => {
    // Block space key completely
    if (e.key === ' ') {
      e.preventDefault();
      return;
    }
  };

  onEmailPaste = (e) => {
    e.preventDefault();
    const pastedText = e.clipboardData.getData('text');
    const sanitizedValue = sanitizeEmailInput(pastedText);
    this.setState({ email: sanitizedValue });
    const emailLength = sanitizedValue.length;
    if (emailLength === 6) {
      this.setState({ isEmailEmpty: false });
    }
  };

  onEmailKeyPress = (e) => {
    if (e.charCode === 13 && this.validateEmail()) {
      // this.textEmailInput.refs.input.focus();
      this.sendEmail();
    }
  };
  sendEmail = () => {
    this.props.nbsForgotPassword(this.state.email);
  };
  renderSpinner = () => {
    return (
      <div className={classes.SpinnerWrapper}>
        <Spinner size='Tiny' />
      </div>
    );
  };

  render() {
    let modalStyle = null;
    if (this.props.isRecoveryPasswordSent && this.props.isLandscape) {
      modalStyle = { width: '30px', minHeight: 'auto', height: 'auto' }; // hide modal behind alert message on desktop
    } else if (this.props.isLandscape) {
      modalStyle = {
        minHeight: 'auto',
        height: 'auto',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      };
    }

    return (
      <Modal
        modalStyle={modalStyle}
        navbarLeftElement={
          <NavbarElement
            fill='var(--svg-color-navigation-light)'
            imgIcon='/sprites.svg#icon-arrow-left'
            alt='Back'
            clicked={this.props.goBack}
          />
        }
        navbarCenterElement={strings.recoveryTittle}
      >
        <div
          className={classes.Content}
          style={{
            display: this.props.isRecoveryPasswordSent ? 'none' : 'auto',
          }}
        >
          <Input
            setRef={(component) => {
              this.textEmailInput = component;
            }}
            type='email'
            inputMode='email'
            autoCapitalize='off'
            autoCorrect='off'
            autoComplete='email'
            value={this.state.email}
            onFocus={this.focusedInput}
            onBlur={this.discardFocusedInput}
            onChange={this.onEmailChange}
            onKeyDown={this.onEmailKeyDown}
            onPaste={this.onEmailPaste}
            label={`${strings.EmailAddress}:`}
            onKeyPress={this.onEmailKeyPress}
            placeholder={strings.EnterEmailAddress}
            invalid={!!this.props.emailErrorMessage}
          />
          {this.renderEmailError()}
        </div>
        <div
          className={classes.FooterWrapper}
          style={{
            display: this.props.isRecoveryPasswordSent ? 'none' : 'auto',
          }}
        >
          <div className={this.state.focus ? classes.Focused : classes.Footer}>
            <Button
              disabled={
                this.props.isRecoveryPasswordSent
                  ? false
                  : !this.validateEmail()
              }
              clicked={
                this.props.isRecoveryPasswordSent
                  ? this.props.goBack
                  : this.sendEmail
              }
            >
              {this.props.isRecoveryPasswordSent
                ? strings.goBackToLogIn
                : strings.recoveryButton}
            </Button>
          </div>
          {this.props.showSpinner ? this.renderSpinner() : null}
        </div>
        {this.props.isRecoveryPasswordSent
          ? this.renderRecoveryMessageAlert()
          : null}
        {this.props.showErrorAlert ? (
          <AlertError
            dismissAlert={this.props.toggleAlertError}
            errorMessage={this.props.emailErrorMessage}
          />
        ) : null}
      </Modal>
    );
  }
}

export default PasswordRecovery;
